import request from '@/utils/request'

const api = {
  areaTreeList(data) {
    return request({
      url: 'admin/area/areaTreeList',
      method: 'post',
      data
    })
  }
}

export default api
